import { useEffect, useState } from "react";
import DashboardLayout from "../Layouts/DashboardLayout";

export default function Payslips() {
  const [payslips, setPayslips] = useState([]);
  const [selected, setSelected] = useState(null);
  const [filterMonth, setFilterMonth] = useState("January 2026");
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(new Date().getFullYear());

  const [summary, setSummary] = useState({});

  useEffect(() => {
    loadPayslips();
  }, [month, year]);

  const loadPayslips = async () => {
    try {
      const res = await fetch(
        `/api/payslips?month=${month}&year=${year}`,
        {
          credentials: "include",
        },
      );

      const data = await res.json();

      if (data.status === "success") {
        setPayslips(data.data);
        setSummary(data.summary);
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const previewPayslip = async (id) => {
    const res = await fetch(`/api/payslips/${id}`, {
      credentials: "include",
    });

    const data = await res.json();

    if (data.status === "success") {
      setSelected(data.data);
    } else {
      alert(data.message);
    }
  };

  const markPaid = async (id) => {
    const payment = prompt("Payment Mode (Cash/Bank/UPI)");

    if (!payment) return;

    const res = await fetch(`/api/payslips/${id}/pay`, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        payment_mode: payment,
      }),
    });

    const data = await res.json();

    if (data.status === "success") {
      alert("Salary Paid");
      loadPayslips();
    } else {
      alert(data.message);
    }
  };

  const generatePayslips = async () => {
    const res = await fetch("/api/payslips/generate", {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        month,
        year,
      }),
    });

    const data = await res.json();

    alert(data.message);

    loadPayslips();
  };

  const printPayslip = (id) => {
    window.open(`/api/payslips/${id}/print`, "_blank");
  };

  const filtered = payslips.filter((p) => p.month === filterMonth);

  return (
    <DashboardLayout>
      <div className="space-y-10">
        {/* ===== HEADER ===== */}
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-serif">Payslips</h1>

          <div className="flex gap-3">
            <select
              value={month}
              onChange={(e) => setMonth(Number(e.target.value))}
              className="px-4 py-2 rounded-xl bg-black/40 border border-white/10"
            >
              {Array.from({ length: 12 }, (_, i) => (
                <option key={i} value={i + 1}>
                  {new Date(0, i).toLocaleString("default", { month: "long" })}
                </option>
              ))}
            </select>

            <input
              type="number"
              value={year}
              onChange={(e) => setYear(Number(e.target.value))}
              className="w-28 px-4 py-2 rounded-xl bg-black/40 border border-white/10"
            />

            <button
              onClick={generatePayslips}
              className="bg-amber-400 text-black px-5 rounded-xl"
            >
              Generate
            </button>
          </div>
        </div>

        <div className="grid md:grid-cols-4 gap-4">
          <SummaryCard label="Payslips" value={summary.total_payslips || 0} />

          <SummaryCard
            label="Total Salary"
            value={`₹${summary.total_salary || 0}`}
          />

          <SummaryCard label="Generated" value={summary.generated || 0} />

          <SummaryCard label="Paid" value={summary.paid || 0} />
        </div>

        {/* ===== TABLE ===== */}
        <div className="rounded-2xl bg-white/5 border border-white/10 overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-black/40 text-gray-400">
              <tr>
                <th className="px-6 py-4 text-left">Employee</th>
                <th className="px-6 py-4">Role</th>
                <th className="px-6 py-4">Month</th>
                <th className="px-6 py-4">Net Pay</th>
                <th className="px-6 py-4">Status</th>
                <th className="px-6 py-4">Actions</th>
              </tr>
            </thead>
            <tbody>
              {payslips.map((p) => (
                <tr
                  key={p.id}
                  className="border-t border-white/10 hover:bg-white/5"
                >
                  <td className="px-6 py-4">{p.employee_name}</td>

                  <td className="text-center">{p.role}</td>

                  <td className="text-center">
                    {new Date(0, p.month - 1).toLocaleString("default", {
                      month: "long",
                    })}{" "}
                    {p.year}
                  </td>

                  <td className="text-center">
                    ₹{p.net_salary.toLocaleString()}
                  </td>

                  <td className="text-center">
                    <span
                      className={`px-3 py-1 rounded-full text-xs
${
  p.status === "Paid"
    ? "bg-green-500/20 text-green-400"
    : "bg-yellow-500/20 text-yellow-400"
}`}
                    >
                      {p.status}
                    </span>
                  </td>

                  <td className="text-center space-x-3">
                    <button
                      className="text-amber-400"
                      onClick={() => previewPayslip(p.id)}
                    >
                      Preview
                    </button>

                    <button
                      className="text-blue-400"
                      onClick={() => printPayslip(p.id)}
                    >
                      Print
                    </button>

                    {p.status !== "Paid" && (
                      <button
                        className="text-green-400"
                        onClick={() => markPaid(p.id)}
                      >
                        Pay
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* ===== PREVIEW MODAL ===== */}
        {selected && (
          <Modal onClose={() => setSelected(null)}>
            <h2 className="text-xl font-serif mb-6">Payslip Preview</h2>

            <Row label="Payslip No" value={selected.payslip_no} />

            <Row label="Employee" value={selected.employee.name} />

            <Row label="Employee ID" value={selected.employee.employee_id} />

            <Row label="Role" value={selected.employee.role} />

            <Row label="Branch" value={selected.employee.branch} />

            <hr className="my-4 border-white/10" />

            <Row label="Working Days" value={selected.payroll.working_days} />

            <Row label="Present" value={selected.payroll.present_days} />

            <Row label="Leave" value={selected.payroll.leave_days} />

            <Row label="Absent" value={selected.payroll.absent_days} />

            <Row
              label="Overtime Hours"
              value={selected.payroll.overtime_hours}
            />

            <hr className="my-4 border-white/10" />

            <Row label="Salary" value={`₹${selected.salary.salary_snapshot}`} />

            <Row
              label="Commission"
              value={`₹${selected.salary.commission_amount}`}
            />

            <Row
              label="Overtime"
              value={`₹${selected.salary.overtime_amount}`}
            />

            <Row label="Bonus" value={`₹${selected.salary.bonus}`} />

            <Row label="Deductions" value={`₹${selected.salary.deductions}`} />

            <hr className="my-4 border-white/10" />

            <Row
              label="Net Salary"
              value={`₹${selected.salary.net_salary}`}
              highlight
            />

            <Row label="Status" value={selected.status} />

            <div className="mt-6 flex gap-3">
              <button
                onClick={() => printPayslip(selected.id)}
                className="flex-1 bg-blue-500 rounded-xl py-2"
              >
                Print
              </button>

              {selected.status !== "Paid" && (
                <button
                  onClick={() => markPaid(selected.id)}
                  className="flex-1 bg-green-500 rounded-xl py-2"
                >
                  Mark Paid
                </button>
              )}
            </div>
          </Modal>
        )}
      </div>
    </DashboardLayout>
  );
}

function Row({ label, value, highlight }) {
  return (
    <div className="flex justify-between">
      <span className="text-gray-400">{label}</span>
      <span className={highlight ? "text-amber-400 font-medium" : ""}>
        {value}
      </span>
    </div>
  );
}

function Modal({ children, onClose }) {
  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center">
      <div className="w-full max-w-xl rounded-2xl bg-[#0b0b0f] border border-white/10 p-8 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-white"
        >
          ✕
        </button>
        {children}
      </div>
    </div>
  );
}

function SummaryCard({ label, value }) {
  return (
    <div className="rounded-2xl bg-white/5 border border-white/10 p-6">
      <p className="text-xs uppercase text-gray-400">{label}</p>
      <p className="mt-2 text-2xl font-serif">{value}</p>
    </div>
  );
}
